// extracted by mini-css-extract-plugin
module.exports = {"cls1":"index-HeroBackground-module--cls1--2a6a1","bright":"index-HeroBackground-module--bright--3S5jw"};